module.exports = __webpack_public_path__ + "img/Analizaorganizacionogmodela.e5287f8d.jpg";